<template>
  <div class="container">
    <div class="block my-reward">
      <img :src="'https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/activity-head-img.png?' + random()" alt="" />
      <div class="reward-card block-content">
        <div class="reward-card-num">
          <div>
            <div>
              <span class="reward-card-money">{{ bonusDetails.uploadBonus }}</span
              >元
            </div>
            <div @click="getRemind('upload')">上传奖励<van-icon style="margin-left: 0.1rem" name="question-o" /></div>
          </div>
          <div>
            <div>
              <span class="reward-card-money">{{ bonusDetails.withdrawAmount }}</span
              >元
            </div>
            <div @click="getRemind('cash')">提现额度<van-icon style="margin-left: 0.1rem" name="question-o" /></div>
          </div>
        </div>
        <div class="reward-card-intr">
          <div>预计可获得奖励{{ bonusDetails.acquireBonus }}元</div>
          <div>奖励会在活动结束后10个工作日内统一发放</div>
        </div>
      </div>
    </div>
    <div class="block reward-list">
      <div class="block-title">
        <img :src="'https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/activity-reward.png?' + random()" alt="" />
      </div>
      <div class="block-content">
        <ul>
          <li v-for="(item, index) in bonusDetails.bonusDetailList" :key="index">
            <div class="list-num">
              <span>{{ item.title }}</span>
              <span>{{ item.bonusAmount }}</span>
            </div>
            <div class="list-time">
              <span>{{ item.createTime }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="block reward-rules">
      <div class="block-title"><img :src="'https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/activity-rule.png?' + random()" alt="" /></div>
      <div class="block-content">
        <p>1.活动时间:9月1日到9月30日</p>
        <p>2.活动对象:限活动时间内上传设备的前100名经纪人</p>
        <p>3.活动详情:</p>
        <p>①前5台可直接获得奖励:每位经纪人的前5台新增设备，每上拍(询价/竞拍)一台可直接获得奖励40元。</p>
        <p>②第6台起奖金翻倍:每位经纪人从第6台新增设备开始，每上拍(询价/竞拍)1台设备获得上传奖励100元，须有对应的提现额度才可进行提现。</p>
        <p>③提现额度:经纪人在平台每成交1台设备，即可获得500元的提现额度，可用于提现上传奖励奖金池中的奖金。</p>
        <p>④提现时间:奖励会在活动结束后10个工作日内统一发放。</p>
        <p>4.奖金发放说明:平台代扣税点后发放</p>
      </div>
    </div>
    <div class="block reward-remind">*本次活动的最终解释权归云联所有</div>
  </div>
</template>
<script>
import { Dialog } from "vant"
export default {
  name: "reward",
  components: {},
  data() {
    return {
      uId: "",
      hasParticipate: false,
      bonusDetails: {},
      showPopover: false
    }
  },
  created() {
    document.title = "百万奖金池，有“机”你就来！"
    let params = this.$route.query
    this.uId = params.uId
    this.hasParticipate = params.hasParticipate == "true"
    this.getDetails()
  },
  methods: {
    getRemind(type) {
      const msg1 = "上传设备并成功发布竞拍/询价后可获得的奖励金额，需有对应的“提现额度”方可提现"
      const msg2 = "设备成交后可获得提现额度，用于提现“上传奖励”中的金额"
      Dialog.alert({
        title: "",
        confirmButtonText: "我知道了",
        confirmButtonColor: "",
        message: type == "upload" ? msg1 : msg2
      }).then(() => {})
    },
    getDetails() {
      const data = {
        uid: this.uId,
        eqpSource: 3
      }
      this.$api.getBonusDetails(data).then((res) => {
        if (res.data.code == 0) {
          this.bonusDetails = res.data.data || {}
        }
      })
    },
    random() {
      return Math.floor(Math.random() * 100 + 1)
    }
  },
  watch: {}
}
</script>
<style lang="scss">
.container {
  .van-cell {
    // background: #ffffff;
    margin-top: 0;
  }
  .van-field__label {
    color: #323233;
  }
}
</style>
<style lang="scss" scoped>
.container {
  font-size: 16px;
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  background-color: #f54d2e;
  box-sizing: border-box;
  overflow: hidden;
  font-family: PingFangSC-Semibold, PingFang SC;
  .block {
    width: 100%;
    box-sizing: border-box;

    .block-title {
      padding: 0.2rem 0;
      padding-top: 0.6rem;
      img {
        height: 0.5rem;
      }
    }
    .block-content {
      background-color: #fff;
      border-radius: 0.2rem;
      padding: 0 0.5rem;
    }
    .block-content,
    .block-title {
      width: 94%;
      margin-left: 3%;
      box-sizing: border-box;
    }
  }
  .my-reward {
    position: relative;
    img {
      width: 100%;
    }
    .reward-card {
      min-height: 5rem;
      position: absolute;
      bottom: 0rem;
      box-sizing: border-box;
      padding-top: 1.4rem;
      background: url("https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/activity-card.png") no-repeat;
      background-size: 100% 100%;
      .reward-card-num {
        display: flex;
        justify-content: space-around;
        color: #905e3b;
        font-size: 0.35rem;
        .reward-card-money {
          color: #662a0f;
          font-size: 0.8rem;
        }
      }
      .reward-card-intr {
        font-size: 0.35rem;
        color: #905e3b;
        padding-top: 0.5rem;
        line-height: 0.6rem;
      }
    }
  }
  .reward-list {
    .block-content {
      min-height: 2.3rem;
      max-height: 12rem;
      overflow-y: auto;
    }
    ul {
      margin: 0;
      padding: 0;
    }
    li {
      list-style: none;
      border-bottom: 1px solid #ccc;
      padding: 0.5rem 0;
      .list-num {
        display: flex;
        justify-content: space-between;
        color: #333333;
        padding: 0.2rem 0;
        font-weight: bold;
      }
      .list-time {
        font-size: 0.3rem;
        color: #999999;
      }
    }
    li:last-child {
      border: 0;
    }
  }
  .reward-rules {
    color: #333333;
    font-size: 0.3rem;
    margin-bottom: 0.6rem;
    .block-content {
      padding: 0.5rem;
      p {
        line-height: 0.5rem;
        margin-bottom: 0.1rem;
      }
    }
  }
  .reward-remind {
    text-align: center;
    padding-bottom: 0.6rem;
    color: #fff;
    font-size: 0.35rem;
  }
}
</style>
